{
    "Accessibility menu": "Menu Aksesibiliti",
    "Reset settings": "Tetapkan semula tetapan",
    "Close": "Tutup",
    "Content adjustments": "Penyesuaian Kandungan",
    "Navigation adjustments": "Penyesuaian Navigasi",
    "Align Left": "Jajar ke Kiri",
    "Adjust Font Size": "Laraskan Saiz Fon",
    "Highlight Title": "Serlahkan Tajuk",
    "Highlight Links": "Serlahkan Pautan",
    "Readable Font": "Fon Mudah Baca",
    "Colour adjustments": "Penyesuaian Warna",
    "Dark Contrast": "Kontras Gelap",
    "Light Contrast": "Kontras Terang",
    "High Contrast": "Kontras Tinggi",
    "High Saturation": "Saturasi Tinggi",
    "Low Saturation": "Saturasi Rendah",
    "Monochrome": "Monokrom",
    "Tools": "Peralatan",
    "Reading Guide": "Panduan Membaca",
    "Stop Animations": "Hentikan Animasi",
    "Big Cursor": "Kursor Besar",
    "Increase Font Size": "Besarkan Saiz Fon",
    "Decrease Font Size": "Kecilkan Saiz Fon",
    "Letter Spacing": "Ruangan Huruf",
    "Line Height": "Ketinggian Garis",
    "Font Weight": "Ketebalan Fon",
    "Dyslexia Font": "Fon Dyslexia",
    "Language": "Bahasa",
    "Accessibility widget": "Buka menu kebolehcapaian",
    "Accessibility Profiles": "Profil Kebolehcapaian",
    "Cognitive Disability": "Kecacatan Kognitif",
    "Seizure Safe": "Selamat untuk Epilepsi",
    "Accessibility statement": "Pernyataan Kebolehcapaian"
}